export default class Obstacle extends Phaser.Group {
  constructor(game, gameLayerRef, x, y, data) {
    super(game);

    this.gameLayerRef = gameLayerRef;
    this.wasHit = false;
    this.wasJumpedOver = false; // this is for villain
    this.data = data;
    this.offset = data.offset;
    this.hitRect = data.hit_rect;
    this.jumpDistance = data.jump_distance;

    this.x = x;
    this.y = y + this.offset.y - 5;

    this.asset = this.game.make.image(this.offset.x, 0, data.sheet, data.key);
    // this.asset.anchor.set(0, 1);
    this.addChild(this.asset);

    this.rect = new Phaser.Rectangle(
      x + this.hitRect.x,
      y + this.hitRect.y,
      this.hitRect.w,
      this.hitRect.h
    );

    // this.debug = this.game.make.graphics();
    // this.debug.beginFill(0xff0000, 0.3);
    // this.debug.drawRect(this.hitRect.x, this.hitRect.y, this.hitRect.w, this.hitRect.h);
    // this.addChild(this.debug);
  }

  getRect() {
    this.rect.x = this.x + this.hitRect.x;
    this.rect.y = this.y + this.hitRect.y;
    return this.rect;
  }

  step(hero, dt) {
    if (this.data.type == 'normal') {
      if (!this.wasHit) {
        if (!hero.m_isDead && hero.m_onGround) {
          var rect0 = hero.getRect();
          var pt0 = hero.parent.toGlobal(rect0); // global position of hero
          var pt0l = this.parent.toLocal(pt0); // local position of hero
          rect0.x = pt0l.x;
          rect0.y = pt0l.y;

          var rect1 = this.getRect();

          if (Phaser.Rectangle.intersects(rect0, rect1)) {
            hero.onHitObstacle();
            this.wasHit = true;
          }
        }
      }
    } else if (this.data.type == 'walkable') {
      if (!this.wasHit) {
        if (!hero.m_isDead) {
          var rect0 = hero.getRect();
          var pt0 = hero.parent.toGlobal(rect0); // global position of hero
          var pt0l = this.parent.toLocal(pt0); // local position of hero
          rect0.x = pt0l.x;
          rect0.y = pt0l.y;

          var rect1 = this.getRect();

          if (Phaser.Rectangle.intersects(rect0, rect1)) {
            hero.onHitBlock(this, rect0, rect1, dt);
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./js/app/games/chase/game/objects/Obstacle.js